import classNames from 'classnames'
import { ReactNode, forwardRef } from 'react'
import { MenuItems as HeadlessMenuItems } from '@headlessui/react'

type ItemsProps = {
    className?: string
    children?: ReactNode
    [x: string]: any
}

export const Items = forwardRef<HTMLDivElement, ItemsProps>(({ className, children, ...props }: ItemsProps, ref) => {
    return (
        <HeadlessMenuItems
            ref={ref}
            {...props}
            className={classNames(className, 'popup focus:outline-hidden z-20 p-1.5')}
            portal
            anchor="bottom start"
        >
            {children}
        </HeadlessMenuItems>
    )
})
